import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cardNumber", "cardExpiry", "cardCvc", "brandIcon", "error", "email", "form"]

  static values = {
    stripeKey: String,
  }

  connect() {
    this.stripe = Stripe(this.stripeKeyValue)
    this.stripeElements = this.stripe.elements()
    this.#mountCardElements()
  }

  disconnect() {
    this.cardNumberEl?.destroy()
    this.cardExpiryEl?.destroy()
    this.cardCvcEl?.destroy()
    this.cardNumberEl = null
    this.cardExpiryEl = null
    this.cardCvcEl = null
    this.stripeElements = null
    this.stripe = null
  }

  handleSubmit(event) {
    event.preventDefault()

    const ownerInfo = { owner: { email: this.emailTarget.value } }

    this.stripe.createSource(this.cardNumberEl, ownerInfo).then((result) => {
      if (result.error) {
        this.#showError(result)
        return
      }

      const hiddenInput = document.createElement("input")
      hiddenInput.setAttribute("type", "hidden")
      hiddenInput.setAttribute("name", "stripeSource")
      hiddenInput.setAttribute("value", result.source.id)
      this.formTarget.appendChild(hiddenInput)
      this.formTarget.submit()
    })
  }

  #mountCardElements() {
    const style = {
      base: {
        iconColor: "#666EE8",
        color: "#31325F",
        lineHeight: "40px",
        fontWeight: 300,
        fontSize: "15px",
        "::placeholder": { color: "#CFD7E0" },
      },
    }

    this.cardNumberEl = this.stripeElements.create("cardNumber", { style })
    this.cardNumberEl.mount(this.cardNumberTarget)
    this.cardNumberEl.on("change", this.#handleCardChange)

    this.cardExpiryEl = this.stripeElements.create("cardExpiry", { style })
    this.cardExpiryEl.mount(this.cardExpiryTarget)

    this.cardCvcEl = this.stripeElements.create("cardCvc", { style })
    this.cardCvcEl.mount(this.cardCvcTarget)
  }

  #handleCardChange = (event) => {
    if (event.brand) this.#setBrandIcon(event.brand)
    this.#showError(event)
  }

  #cardBrandToPfClass = {
    visa: "pf-visa",
    mastercard: "pf-mastercard",
    amex: "pf-american-express",
    discover: "pf-discover",
    diners: "pf-diners",
    jcb: "pf-jcb",
    unknown: "pf-credit-card",
  }

  #setBrandIcon(brand) {
    const el = this.brandIconTarget
    const pfClass = this.#cardBrandToPfClass[brand] || "pf-credit-card"
    el.className = ""
    el.classList.add("pf", pfClass)
  }

  #showError(event) {
    const el = this.errorTarget
    el.classList.remove("visible")

    if (event.error) {
      el.textContent = event.error.message
      el.classList.add("visible")
    }
  }
}
